import TaxDocumentSetting from './TaxDocumentSetting';

export default TaxDocumentSetting;
